@for (question of gradingQuestions(); track question.question) {
  <div class="summary-row">
    <span class="summary-question">{{ question.question }}</span>
    @if (getGradingQuestionAnswer(question.questionType); as answer) {
      <span class="summary-answer">
        {{ answer }}
      </span>
    }
  </div>
}
